// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container .mainFooter[data-v-733cb1e0] {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.24rem;\n  background-color: #f3f3f3;\n  padding: 0.15rem;\n}\n.container .mainFooter .left[data-v-733cb1e0] {\n    font-size: 0.12rem;\n}\n.container .p3[data-v-733cb1e0] {\n  margin-bottom: 0.24rem;\n}\n.container .p3 span[data-v-733cb1e0] {\n    color: #dc7039;\n    font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
